var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('error'),_c('confirmation'),_c('notice'),_c('context-menu',[_c('div',{staticClass:"container-fluid"},[_c('router-view',{key:_vm.$route.name})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }